'use client';
import {Suspense,createContext,useContext,useEffect,useState} from 'react';
import {useSearchParams,useRouter} from 'next/navigation';
import {locales,localeNames,messages,localeFromSearch,localizedPath,isPublicPagePath,type Locale} from '@zzy/contracts';
import styles from './preference-controls.module.css';
const LocaleContext=createContext({locale:'zh-CN' as Locale,setLocale:(_locale:Locale)=>{}});
function LocaleUrlSync({onChange}:{onChange:(locale:Locale)=>void}){
 const search=useSearchParams(),query=search.toString();
 useEffect(()=>{onChange(localeFromSearch(new URLSearchParams(query)))},[query,onChange]);
 return null;
}
export function LocaleProvider({children,initialLocale='zh-CN'}:{children:React.ReactNode;initialLocale?:Locale}){
 const [locale,setLocale]=useState<Locale>(initialLocale);
 const router=useRouter();
 useEffect(()=>{document.documentElement.lang=locale;document.cookie='zzy-locale='+locale+'; Path=/; Secure; SameSite=Lax; Max-Age=31536000'},[locale]);
 const chooseLocale=(next:Locale)=>{
  if(!locales.includes(next))return;
  setLocale(next);
  const target=localizedPath(location.pathname+location.search+location.hash,next);
  if(isPublicPagePath(location.pathname))router.replace(target,{scroll:false});
  else history.replaceState(history.state,'',target);
 };
 return <LocaleContext.Provider value={{locale,setLocale:chooseLocale}}><Suspense fallback={null}><LocaleUrlSync onChange={setLocale}/></Suspense>{children}</LocaleContext.Provider>
}
export function useMessages(){const {locale}=useContext(LocaleContext);return messages[locale]}
export function LanguageSelect({compact=false}:{compact?:boolean}={}){const {locale,setLocale}=useContext(LocaleContext);return <label className={compact?`${styles.control} ${styles.language}`:'language-label'} title={messages[locale].language}><span className="sr-only">{messages[locale].language}</span>{compact&&<span aria-hidden="true">{locale.split('-')[0]!.toUpperCase()}</span>}<select className={styles.select} aria-label={messages[locale].language} value={locale} onChange={e=>setLocale(e.target.value as Locale)}>{locales.map(l=><option key={l} value={l}>{localeNames[l]}</option>)}</select></label>}
